module.exports = __webpack_public_path__ + "img/DE05892.6d2ecd50.png";